import React from 'react';
import PropTypes from 'prop-types';
import { Paper } from '@mui/material';
import { borderRadius } from '../../Tokens/Scales';
import { borders } from '../../Tokens/Colors';

const AppPaper = React.forwardRef(({
  children,
  elevation = 0,
  noBorder = false,
  sx,
  ...props
}, ref) => (
  <Paper
    ref={ref}
    elevation={elevation}
    sx={{
      borderRadius: borderRadius.xs,
      border: noBorder ? 'none' : borders.default,
      backgroundColor: '#ffffff',
      ...sx,
    }}
    {...props}
  >
    {children}
  </Paper>
));

AppPaper.displayName = 'AppPaper';

AppPaper.propTypes = {
  children: PropTypes.node,
  elevation: PropTypes.number,
  noBorder: PropTypes.bool,
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

export default AppPaper;
